import type { ReactNode } from 'react';
import { styled } from 'styled-components';
import { Text } from '../Text';

export const StyledMenuItemDescription = styled(Text)`
  /* avoid no-empty-source rule */
`;

export type MenuItemDescriptionProps = {
  /**
   * The content of the description
   */
  children: ReactNode;
};

export const MenuItemDescription = ({ children }: MenuItemDescriptionProps) => {
  return (
    <StyledMenuItemDescription
      prominence="secondary"
      variant="body4"
    >
      {children}
    </StyledMenuItemDescription>
  );
};
